export default import.meta.ROLLDOWN_FILE_URL_hBDNg4RECWblwnDO8Y9tbw